import * as React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import ModalWrapper from '../../../components/modalWrapper';

const ModalCreateClaimTerminationWarning  = ({
  openModal,
  setModalWrapper,
}) => {
  const router = useNavigate();
  const { t } = useTranslation();

  return (
    <ModalWrapper
      headerTitle={t('contractRevoked')}
      openModal={openModal}
      setModalWrapper={() => setModalWrapper(false)}
    >
      <>
        <div
          className="modal_container__body__text"
          style={{ maxWidth: 580 }}
        >
          {t('cannotUploadNewClaims')}
        </div>
        <div
          className="modal_container__body__inputs"
          style={{ rowGap: '5px' }}
        >
          <div
            className="button_red_small"
            style={{ width: 250 }}
            onClick={() => {
              setModalWrapper(false);
              router('/');
            }}
          >
            {t('toStartPage')}
          </div>
        </div>
      </>
    </ModalWrapper>
  )
}

export default ModalCreateClaimTerminationWarning ;
